<template>
    <section class="home-container">
        <MasterPage title="医嘱管理">
            <div slot="title-icon">
                <Icon type="md-analytics" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="患者账号：">
                            <Select v-model="select.userId" clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="时间段：">
                            <DatePicker v-model="select.dataTime" type="datetimerange" placeholder="请选择时间段" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医嘱状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增医嘱" @on-cancel="cancelItem">
            <Form label-position="top">
                <FormItem label="患者账号：">
                    <Select v-model="itemAdd.userId" clearable placeholder="请选择">
                        <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="医嘱说明：">
                    <Input v-model="itemAdd.content" type="textarea" :autosize="{minRows:10,maxRows: 10}"placeholder="请输入用药指示与医学指令。。。" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改医嘱" @on-cancel="cancelItem">
            <Form label-position="top">
                <FormItem label="患者账号：">
                    <Select v-model="updateInfoItem.userId" clearable placeholder="请选择">
                        <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="医嘱说明：">
                    <Input v-model="updateInfoItem.content" type="textarea" :autosize="{minRows:10,maxRows: 10}"placeholder="请输入用药指示与医学指令。。。" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="医嘱详情" width="750">
            <Form :label-width="100">
                <FormItem label="患者账号：">
                    {{infoItem.user.name}}
                </FormItem>
                <FormItem label="医嘱说明：">
                    <p v-html="infoItem.content"></p>
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '患者',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', params.row.user.name)
                        }
                    },
                    {
                        title: '时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value= params.row.createTime
                            if (value==undefined || value.length <=0)return
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hs = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span', y+'-'+m+'-'+d+' '+hs+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            Buttons.push(
                                [h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-cloud-download',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.dowmItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '下载')
                                ]
                            )
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                userAllList:[],
                select:{
                    userId:'',
                    dataTime:[],
                    isDeleted:'false',
                },
                itemAdd:{
                    userId:'',
                    content:'',
                },
                updateInfoItem:"",
                infoItem:{user:{name:''}},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('doctorAdvice/list',{
                    userId:this.select.userId == undefined ? "" : this.select.userId,
                    startTime:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    endTime:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.userId.length <= 0){
                    return this.$Message.warning('请选择患者账号');
                }
                if (this.itemAdd.content.length <= 0){
                    return this.$Message.warning('请输入医嘱详情');
                }
                this.itemAdd.content = this.itemAdd.content.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
                this.addLoading = true
                this.$http.post('doctorAdvice/add',
                    this.itemAdd,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医嘱新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医嘱新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.userId.length <= 0){
                    return this.$Message.warning('请选择患者账号');
                }
                if (this.updateInfoItem.content.length <= 0){
                    return this.$Message.warning('请输入医嘱详情');
                }
                this.updateInfoItem.content = this.updateInfoItem.content.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
                this.updateLoading = true
                this.$http.post('doctorAdvice/update',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd.userId = this.itemAdd.content = ''
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用“'+ item.user.name + '”的医嘱',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('doctorAdvice/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用“'+ item.user.name + '”的医嘱',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('doctorAdvice/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            dowmItem_modal(item){
                let downLink = document.createElement('a')
                downLink.style.display = 'none';
                downLink.download = item.user.name+'_'+item.createTime.substr(0,10) +'.doc'
                let blob = new Blob([item.content])
                downLink.href = URL.createObjectURL(blob)
                document.body.appendChild(downLink)
                downLink.click()
                document.body.removeChild(downLink)
            }
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


